module.exports = __webpack_public_path__ + "static/media/popup-image-musicaolicos.6752e8af.png";